export const labels: { [key: string]: string } = {
  additionalFirstnames: 'Additional first name(s)',
  additionalMiddlenames: 'Additional middle name(s)',
  additionalLastnames: 'Additional last name(s)',
  aNumber: 'A-Number',
  birthCountry: 'Birth country',
  citizenshipEligibilityDate: 'Citizenship Eligibility Date',
  birthDate: 'Date of birth',
  birthState: 'Birth state/province',
  birthCity: 'Birth city/town',
  citizenshipCountry: 'Country(ies) of citizenship',
  chargeabilityCountry: 'Country of Chargeability',
  company: 'Company',
  criminalHistory: `Have you, or any other person on your case, EVER ordered, 
    incited, called for, committed, assisted, helped with, or otherwise
    participated in any of the following:`,
  dependents: 'Number of children',
  eadNumber: 'EAD number',
  email: 'Email',
  emailPersonal: 'Personal email',
  emailWork: 'Work Email',
  firstname: 'First name',
  hasApprovedI140: 'Do you have an approved I-140?',
  hasBeenEmployedSinceLastAdmitted: `Have you, or any other person on the case, 
    been employed in the United States since last admitted or granted an
    extension or change of status?`,
  hasBeenArrestedSinceLastUSEntry: `Have you, or any other person on your case, 
    EVER been arrested or convicted of any criminal offense since last entering
    the United States?`,
  hasCriminalOffence: `Have you ever commited, been arrested for, been charged 
    or convicted of any criminal offense in any country (including any D.U.I.
    conviction)?`,
  hasHadI485Filed: `Has Form I-485, Application to Register Permanent Residence 
    or Adjust Status, EVER been filed by you or by any other person on this
    case?`,
  hasHadVisaPetitionRevokedOrDenied: `Have you ever had a visa petition revoked
    or denied by the U.S. government?`,
  hasNonUSPassport: 'Do you have a valid non-U.S. passport?',
  aosFilingEligible: 'Eligible for AOS Filing',
  hasPendingETA9089: `Do you have a pending ETA 9089 (PERM) filled with the
    U.S. Department of Labor`,
  hasPendingUSCISApplication: `Do you or your dependents have any pending 
    applications with USCIS?`,
  hasSSN: 'Do you have a U.S. Social Security number?',
  hasUsedWeapons: `Have you, or any other person on your case, EVER been a 
    member of, assisted, or participated in any group, unit, or organization
    of any kind in which you or other persons used any type of weapon against
    any person or threatened to do so?`,
  hasTransportedWeapons: `Have you, or any other person included on the application, EVER assisted 
    or participated in selling, providing, or transporting weapons to any
    person who, to your knowledge, used them against another person?`,
  hasParticipatedInArmedGroup: `Have you, or any other person included on the 
    application, EVER served in, been a member of, assisted, or participated in
    any military unity, paramilitar unit, police unit, self-defense unit,
    vigilante unit, rebel group, guerrilla group, militia, insurgent
    organization, or any other armed group?`,
  hasDetailedPerson: `Have you, or any other person on this case, EVER worked, volunteered, or 
    otherwise served in any prison, jail, prison camp, detention facility,
    labor camp, or any other situation that involved detailing persons?`,
  hasValidOrExpiredEAD: `Do you have a valid or expired Employment 
    Authorization Document (EAD) card?`,
  hasViolatedVisaTerms: `Have you, or any other person on this case, done 
    anything that violated the terms of the nonimmigrant status you now hold?`,
  hasWeaponsTraining: `Have you, or any other person on this case, EVER 
    received an type of military, paramilitary, or weapons training?`,
  i94ArrivalDepartureRecordNumber: 'I-94 arrival-departure record number',
  immigrantVisaApplicant: `Are you, or any person included on your case, an 
    applicant for an immigrant visa?`,
  immigrantPetitionEverFiled: `Has an immigrant petition EVER been filed for 
    you or for any person on your case?`,
  'immigrationStatus/status': 'Current visa or immigration status',
  'immigrationStatus/expiration': 'Date status expires',
  isInRemovalProceedings: `Are you, or any other person included on this case, 
    now in removal proceedings?`,
  j1j2: 'Have you or anyone on your case ever had a J-1 or J-2 visa?',
  jobDescriptionID: 'Job title',
  lastAddressOutsideUS: 'Last Address Outside the U.S.',
  lastEntryUS: 'Date of last entry to U.S.',
  lastname: 'Last name',
  licensingAuthority: 'Licensing authority',
  manager: 'Manager',
  maritalStatus: 'Marital status',
  middlename: 'Middle name',
  nickname: 'Nickname',
  nivMaxout: 'NIV max out date',
  nonImmigrantVisaNumber: 'Nonimmigrant visa number',
  offeredSalary: 'Offered salary',
  passportCountry: 'Passport Country',
  passportExpirationDate: 'Passport expiration date',
  passportGender: 'Sex as listed on passport',
  passportIssueDate: 'Passport issue date',
  passportNumber: 'Passport number',
  phone: 'Phone number',
  phoneHome: 'Home phone number',
  phoneWork: 'Work phone number',
  position: 'Position',
  sevisNumber: 'SEVIS number',
  spouse: 'Has spouse?',
  stateBarNumber: 'State bar number',
  title: 'Title',
  usMailingAddress: 'U.S. Mailing Address',
  usResidentialAddress: 'Current U.S. Residential Address',
  usSSN: 'U.S. Social Security number',
  visaConsulate: 'Consulate that issued the Visa',
  visaIssueDate: 'Visa issue date',
  employeeId: 'Employee ID',
  workLocation: 'Work Location',
  visaExpiration: 'Visa Expiration Date',
  socCode: 'SOC Code',
  startDate: 'Start Date',
  firstEntryUS: 'Date of first entry to U.S.',
  taxTrackingF1J1: 'F-1/J-1 Tax Tracking',
  personalEmail: 'Personal email',
  personalPhone: 'Personal Phone Number',
};

export default labels;
